import Vue from 'vue';
import Vuelidate from 'vuelidate';
import VueNoty from 'vuejs-noty';
import ChangePaymentMethodForm from "./components/PremiumSubscriptions/ChangePaymentMethodForm.vue";
import Collapsible from "./components/PremiumSubscriptions/Collapsible.vue";
import Tabs from "./components/PremiumSubscriptions/Tabs.vue";
import TabButton from "./components/PremiumSubscriptions/TabButton.vue";
import TabPanel from "./components/PremiumSubscriptions/TabPanel.vue";
import ReferralModule from "./components/PremiumSubscriptions/ReferralModule.vue";
import { VueperSlides, VueperSlide } from 'vueperslides'

import 'es6-promise/auto';
Vue.use(Vuelidate);
Vue.use(VueNoty, {
    theme: "metroui"
});

import VueLoadScript from 'vue-load-script-plus'
Vue.use(VueLoadScript);

if (document.getElementById('app')) {
    const app = new Vue(
        {
            el: '#app',
            components: {
                'change-payment-method': ChangePaymentMethodForm,
                'collapsible': Collapsible,
                'vueper-slides': VueperSlides,
                'vueper-slide': VueperSlide,
                'tabs': Tabs,
                'tab-button': TabButton,
                'tab-panel': TabPanel,
                'referral-module': ReferralModule,
            }
        }
    )
}
